module.exports = __webpack_public_path__ + "img/word.4bc363ce.png";